import * as React from 'react';



export default class Thumbnail extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="files-display-icon" fillRule="evenodd">
            <g id="Group-28">
                <g transform="translate(1.000000, 1.000000)">
                    <rect id="Rectangle-8" x="0.5" y="0.5" width="5" height="5" rx="1"></rect>
                    <rect id="Rectangle-8-Copy" x="8.5" y="0.5" width="5" height="5" rx="1"></rect>
                    <rect id="Rectangle-8-Copy-3" x="0.5" y="8.5" width="5" height="5" rx="1"></rect>
                    <rect id="Rectangle-8-Copy-2" x="8.5" y="8.5" width="5" height="5" rx="1"></rect>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
